import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ImageUploadWidget from './ImageUploadWidget';
import * as UploadActions from '../../../../actions/images';
import Url from '../../../../../lib/config';

class ThemeImages extends Component {
    render() {
        return (
            <div className="ThemeImages Theme-Content">
                <h1>Images</h1>
                <p className="normal-text">Select the images for your booking engine.</p>
                <div className="subpages-main-content">
                    <div className="col-xs-12">
                        <div className="spark-panel spark-mar-t-1 spark-panel-images row">
                            <div className="spark-panel__content col-xs-12">
                                <ImageUploadWidget
                                    id="image-logo-upload"
                                    title="Logo"
                                    description="Upload a logo image to replace your hotel name."
                                    onDrop={this.props.onHotelNameUpload(this.props.hotel.Id)}
                                    image={this.props.hotelLogo}
                                    items={this.props.available.hotelLogo}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <div className="spark-panel spark-mar-t-1 spark-panel-images row">
                            <div className="spark-panel__content col-xs-12">
                                <ImageUploadWidget
                                    id="image-background-upload"
                                    title="Background Image"
                                    description="Choose a background image for your booking engine."
                                    onDrop={this.props.onBackGroundImageUpload(this.props.hotel.Id)}
                                    image={this.props.backgroundImage}
                                    items={this.props.available.backgroundImage}
                                />
                            </div>
                        </div>
                    </div>
                    {/*<div className="col-xs-12">
           <div className="spark-panel spark-mar-t-1 spark-panel-images row">
           <div className="spark-panel__content col-xs-12">
           <h4>Image Library</h4>
           <ImageGallery items={this.props.available.backgroundImage} slideInterval={2000}
           showPlayButton={false} showBullets={true}/>
           </div>
           </div>
           </div>*/}
                </div>
            </div>
        );
    }
}

ThemeImages.propTypes = {
    children: PropTypes.element,
    hotelLogo: PropTypes.object
};

const mapStateToProps = state => {
    return {
        ...state.assetUpload,
        ...state.theme.images,
        ...state.app.selected
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onHotelNameUpload: hotelId => images => {
            images.map(image => dispatch(UploadActions.uploadHotelLogo(image, hotelId)));
        },
        onBackGroundImageUpload: hotelId => images => {
            images.map(image => dispatch(UploadActions.uploadBackgroundImage(image, hotelId)));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeImages);



// WEBPACK FOOTER //
// ./src/components/pages/theme/images/index.js